export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/account-icon.svg?c65a55ed065c4c7aeff32a310e999062";